import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft } from 'lucide-react';

const LegalPageLayout = ({ title, subtitle, lastUpdated = 'August 26, 2026', children }) => {
  return (
    <div className="pt-20">
      <Helmet>
        <title>{title} | Aurora Wealth Reserves</title>
        <meta name="description" content={`${title} — Aurora Wealth Reserves. ${subtitle || ''}`} />
      </Helmet>

      <section className="relative overflow-hidden bg-gradient-to-br from-primary-900 via-primary-800 to-heritage-800 text-white">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(201,162,39,0.15),_transparent_55%)]" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </Link>
          <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight mb-3">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg text-blue-100/90 max-w-2xl">{subtitle}</p>
          )}
          <p className="mt-6 text-sm text-white/60">Last updated: {lastUpdated}</p>
        </div>
      </section>

      <section className="bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
          <article className="legal-content bg-white rounded-2xl border border-slate-200/80 shadow-sm px-6 py-8 md:px-10 md:py-12 text-slate-700 leading-relaxed space-y-4 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:text-primary-900 [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:font-semibold [&_p]:text-base [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_li]:text-slate-700 [&_a]:text-heritage-700 [&_a]:underline-offset-2 hover:[&_a]:underline [&_strong]:text-slate-900">
            {children}
          </article>

          <div className="mt-10 flex flex-wrap gap-4 text-sm">
            <Link to="/privacy" className="text-heritage-700 hover:underline">Privacy Policy</Link>
            <Link to="/terms" className="text-heritage-700 hover:underline">Terms of Service</Link>
            <Link to="/security" className="text-heritage-700 hover:underline">Security Center</Link>
            <Link to="/disclosures" className="text-heritage-700 hover:underline">Disclosures</Link>
            <Link to="/contact" className="text-heritage-700 hover:underline">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPageLayout;
